/* ===========================================================
  TU Sale Page – JavaScript
  Version: 1.1 (Bug-Fixes: Init-Guard, Variant-Selector)
  Pfad: assets/tu-sale-page.js
=========================================================== */

(function() {
  'use strict';

  /* ===========================================================
    ICONS – zentrale SVG-Sammlung (ersetzt die früheren Emojis)
  =========================================================== */
  const TU_ICONS = {
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="10" width="19" height="11.5" rx="1.5"></rect><line x1="12" y1="10" x2="12" y2="21.5"></line><path d="M2.5 10h19"></path><path d="M12 10S10.5 2.5 7 2.5a2.8 2.8 0 0 0 0 5.6"></path><path d="M12 10s1.5-7.5 5-7.5a2.8 2.8 0 0 1 0 5.6"></path></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="4 12.5 9.5 18 20 6"></polyline></svg>'
  };

  /* ===========================================================
    INITIALISIERUNG MIT GUARD
    Wichtig: Wir markieren initialisierte Sections, damit die
    Event-Listener nie doppelt registriert werden – auch wenn
    der Theme-Editor 'shopify:section:load' mehrfach feuert.
  =========================================================== */
  function initSaleSection(section) {
    if (!section) return;
    if (section.dataset.tuInitialized === '1') return;
    section.dataset.tuInitialized = '1';

    initStickyBar(section);
    initCardSliders(section);
    initBundleSelector(section);
    initCountdown(section);
    initInfoPopup(section);
    initVariantSelectors(section);
    initQuickAdd(section);
    initSmoothScroll(section);
    initReviewsIo(section);
  }


  /* ===========================================================
    PRODUKTKARTEN-BILDSLIDER
    Das Wischen selbst macht CSS (Scroll-Snap). Hier synchronisieren
    wir nur die Punkte mit dem aktuell sichtbaren Bild – performant
    über IntersectionObserver, Fallback auf Scroll-Rechnung.
  =========================================================== */
  function initCardSliders(section) {
    const sliders = section.querySelectorAll('[data-tu-card-slider]');
    sliders.forEach(function(slider) {
      const track = slider.querySelector('[data-tu-card-slider-track]');
      const dotsWrap = slider.querySelector('[data-tu-card-slider-dots]');
      if (!track) return;
      const slides = Array.prototype.slice.call(track.children);
      const dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.children) : [];

      function setActive(i) {
        dots.forEach(function(d, di) {
          d.classList.toggle('is-active', di === i);
        });
      }

      // Manuelle Varianten-Bild-Zuordnung (Titel -> URL) aus dem JSON-Block lesen.
      let variantImageMap = {};
      const mapEl = slider.querySelector('[data-tu-variant-images]');
      if (mapEl) {
        try { variantImageMap = JSON.parse(mapEl.textContent); } catch (e) { variantImageMap = {}; }
      }

      // Tauscht das erste Slide (Hero) auf das dem Varianten-TITEL zugeordnete Bild.
      function setVariantImage(title, smooth) {
        if (!title) return false;
        const url = variantImageMap[title];
        if (!url) return false; // keine Zuordnung -> Hero bleibt
        const heroSlide = track.querySelector('[data-tu-variant-hero]');
        if (!heroSlide) return false;
        const img = heroSlide.querySelector('img');
        if (img && img.getAttribute('src') !== url) {
          img.setAttribute('src', url);
          img.removeAttribute('srcset');
        }
        track.scrollTo({ left: 0, behavior: smooth ? 'smooth' : 'auto' });
        setActive(0);
        return true;
      }
      // IMMER an die Karte hängen – auch bei nur 1 Slide, damit der
      // Varianten-Bildwechsel funktioniert.
      const card = slider.closest('[data-tu-product-block]') || slider.closest('.tu-product-card');
      if (card) card._tuCardSlider = { setVariantImage: setVariantImage };

      // Punkte-Sync nur sinnvoll ab 2 Slides
      if (slides.length < 2) return;

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(function(entries) {
          entries.forEach(function(e) {
            if (e.isIntersecting && e.intersectionRatio >= 0.6) {
              const idx = slides.indexOf(e.target);
              if (idx > -1) setActive(idx);
            }
          });
        }, { root: track, threshold: [0.6] });
        slides.forEach(function(s) { io.observe(s); });
      } else {
        track.addEventListener('scroll', function() {
          const idx = Math.round(track.scrollLeft / track.clientWidth);
          setActive(Math.max(0, Math.min(idx, slides.length - 1)));
        }, { passive: true });
      }

      // Desktop-Pfeile: ein Slide vor/zurück scrollen.
      const prevBtn = slider.querySelector('[data-tu-card-prev]');
      const nextBtn = slider.querySelector('[data-tu-card-next]');
      function currentIndex() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }
      function scrollToIndex(i) {
        const clamped = Math.max(0, Math.min(i, slides.length - 1));
        track.scrollTo({ left: slides[clamped].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      function updateArrows() {
        const i = currentIndex();
        if (prevBtn) prevBtn.disabled = i <= 0;
        if (nextBtn) nextBtn.disabled = i >= slides.length - 1;
      }
      if (prevBtn) prevBtn.addEventListener('click', function() { scrollToIndex(currentIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { scrollToIndex(currentIndex() + 1); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  }


  /* ===========================================================
    STICKY BAR
    Die Bar steht normal unter dem Menü im Seitenfluss. Sobald sie
    beim Scrollen oben rausrutschen würde, klebt sie fest (CSS:
    position: sticky) und wandert mit nach unten.

    Damit sie nicht UNTER dem Vision-Sticky-Header verschwindet,
    messen wir dessen Höhe und schreiben sie in --tu-sticky-offset.
    Wenn der Header nicht sticky/fixed ist, bleibt der Offset 0.
  =========================================================== */
  function initStickyBar(section) {
    const bar = section.querySelector('.tu-sticky-bar');
    if (!bar) return;

    /* Findet das Element, das oben am Bildschirm KLEBT – unabhängig davon,
       wie es heißt. Wir prüfen das Verhalten, nicht den Namen:
       - position fixed oder sticky
       - sitzt ganz oben (Oberkante nahe 0)
       - ist breit (echte Kopfzeile, kein kleines Badge)
       - ist nicht unsere eigene Bar
       Das ist robust gegen jedes Theme, weil es keine Selektoren rät. */
    function findStickyHeader() {
      let best = null;
      const candidates = document.querySelectorAll(
        'header, [class*="header"], [id*="header"], [class*="Header"], sticky-header, [data-sticky], [class*="sticky"]'
      );
      for (const el of candidates) {
        if (el === bar || bar.contains(el) || el.contains(bar)) continue;
        const cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
        const r = el.getBoundingClientRect();
        // klebt oben (Toleranz für kleine Offsets) und ist breit genug
        if (r.top > 4 || r.height < 20 || r.width < window.innerWidth * 0.6) continue;
        if (cs.visibility === 'hidden' || cs.display === 'none' || r.height === 0) continue;
        // das unterste solcher Elemente gewinnt (tiefste Kopfzeilen-Kante)
        if (!best || r.bottom > best.bottom) best = { el: el, bottom: r.bottom, height: r.height };
      }
      return best;
    }

    // Alte namensbasierte Liste bleibt als Fallback erhalten
    const HEADER_SELECTORS = [
      '.section-header.shopify-section-header-sticky',
      '.shopify-section-header-sticky',
      '.header-wrapper--sticky',
      '.header-wrapper',
      'sticky-header',
      '#shopify-section-header',
      '.section-header',
      '.header__wrapper',
      'header.header',
      '#header',
      '.site-header'
    ];

    function findByName() {
      for (let i = 0; i < HEADER_SELECTORS.length; i++) {
        const el = document.querySelector(HEADER_SELECTORS[i]);
        if (!el) continue;
        const pos = window.getComputedStyle(el).position;
        // Nur echte sticky/fixed Header erzeugen einen Offset
        if (pos === 'fixed' || pos === 'sticky') return el;
      }
      return null;
    }

    function applyOffset() {
      // 1. Priorität: das Element, das WIRKLICH oben klebt (verhaltensbasiert,
      //    findet jeden Header ohne Namen). 2. Fallback: bekannte Selektoren.
      //    3. Manueller Wert nur, wenn Auto explizit AUS ist.
      const auto = section.dataset.tuStickyAuto !== 'false';
      let headerH = 0;

      if (auto) {
        const hit = findStickyHeader();
        if (hit) {
          headerH = Math.round(hit.bottom); // Unterkante des klebenden Headers
        } else {
          const named = findByName();
          headerH = named ? Math.round(named.getBoundingClientRect().bottom) : 0;
        }
      } else {
        const isDesktop = window.matchMedia('(min-width: 768px)').matches;
        const key = isDesktop ? 'tuStickyOffsetDesktop' : 'tuStickyOffsetMobile';
        headerH = parseInt(section.dataset[key] || '0', 10) || 0;
      }

      if (headerH < 0) headerH = 0;
      const barH = Math.round(bar.getBoundingClientRect().height);

      section.style.setProperty('--tu-sticky-offset', headerH + 'px');
      section.style.setProperty('--tu-sticky-bar-height', barH + 'px');
      document.documentElement.style.setProperty('--tu-sticky-offset', headerH + 'px');
      document.documentElement.style.setProperty('--tu-sticky-bar-height', barH + 'px');
    }

    applyOffset();
    window.addEventListener('resize', debounce(applyOffset, 150));
    window.addEventListener('load', applyOffset);
    // Header lädt/verschiebt sich oft verzögert (Vision lazy-init, Web-Fonts) → nachmessen
    setTimeout(applyOffset, 300);
    setTimeout(applyOffset, 800);
    setTimeout(applyOffset, 1500);
    // Beim ersten Scroll nochmal – dann steht der sticky Header sicher
    window.addEventListener('scroll', function once() {
      applyOffset();
      window.removeEventListener('scroll', once);
    }, { passive: true, once: true });

    // Schatten + Live-Nachführung: der Header kann beim Scrollen seine Höhe
    // ändern (Vision verkleinert manche Header beim Runterscrollen). Deshalb
    // messen wir bei Auto-Modus auch während des Scrollens nach.
    let pinned = false;
    let scrollRaf = null;
    function onScroll() {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function() {
        scrollRaf = null;
        if (section.dataset.tuStickyAuto !== 'false') applyOffset();
        checkPinned();
      });
    }
    function checkPinned() {
      const offset = parseInt(
        window.getComputedStyle(bar).getPropertyValue('top'), 10
      ) || 0;
      const isPinned = Math.round(bar.getBoundingClientRect().top) <= offset + 1;
      if (isPinned !== pinned) {
        pinned = isPinned;
        bar.classList.toggle('is-pinned', pinned);
      }
    }
    checkPinned();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Warnung, falls ein Parent position:sticky aushebelt (overflow-Falle)
    let node = bar.parentElement;
    while (node && node !== document.body) {
      const ov = window.getComputedStyle(node).overflow;
      if (ov === 'hidden' || ov === 'clip' || ov === 'auto' || ov === 'scroll') {
        console.warn('[TU Sale Page] Sticky Bar wird evtl. blockiert – overflow:' + ov + ' auf', node);
        break;
      }
      node = node.parentElement;
    }
  }

  function debounce(fn, wait) {
    let t;
    return function() {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }


  /* ===========================================================
    REVIEWS.IO – Snippet-Loader manuell triggern
    Auf Custom-Pages lädt Reviews.io die Sterne nicht automatisch.
    Wir triggern die Initialisierung manuell, sobald wir eine
    Snippet-Box mit data-pending="true" finden.
  =========================================================== */
  function initReviewsIo(section) {
    const snippets = section.querySelectorAll('.ruk_rating_snippet');
    if (!snippets.length) return;

    // Reviews.io schreibt lange Labels wie "(22 geprüfte Kundenrezensionen)".
    // Neben den Sternen bricht das auf zwei Zeilen um -> wir kürzen es auf
    // "(22 Bewertungen)". Läuft per MutationObserver, weil das Widget
    // asynchron rendert und sich beim Variantenwechsel neu aufbaut.
    const SHORTEN = [
      [/gepr[üu]fte\s+Kundenrezensionen/gi, 'Bewertungen'],
      [/Kundenrezensionen/gi, 'Bewertungen'],
      [/gepr[üu]fte\s+Rezensionen/gi, 'Bewertungen'],
      [/Rezensionen/gi, 'Bewertungen'],
      [/verified\s+reviews/gi, 'Bewertungen']
    ];

    function shortenIn(root) {
      let walker;
      try {
        walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      } catch (e) { return; }
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function(node) {
        const original = node.nodeValue;
        if (!original) return;
        if (original.indexOf('ezension') === -1 && original.indexOf('eview') === -1) return;
        let updated = original;
        SHORTEN.forEach(function(pair) {
          updated = updated.replace(pair[0], pair[1]);
        });
        if (updated !== original) node.nodeValue = updated;
      });
    }

    snippets.forEach(function(snippet) {
      shortenIn(snippet);
      if (typeof MutationObserver === 'function') {
        const mo = new MutationObserver(function() { shortenIn(snippet); });
        mo.observe(snippet, { childList: true, subtree: true, characterData: true });
      }
    });

    let attempts = 0;
    const maxAttempts = 30; // 30 × 200 ms = 6 Sekunden Timeout

    function tryInit() {
      attempts++;

      // Reviews.io legt verschiedene globale Methoden an, je nach Account-Setup
      // Wir probieren die gängigsten durch
      try {
        if (typeof window.richSnippetReviewsWidgets === 'function') {
          snippets.forEach(function(snippet) {
            const sku = snippet.getAttribute('data-sku');
            if (sku) {
              window.richSnippetReviewsWidgets('ruk_rating_snippet', {
                store: snippet.getAttribute('data-store') || undefined,
                sku: sku,
                hideIfEmpty: false
              });
            }
          });
          return true;
        }
        if (window.RIO && typeof window.RIO.refresh === 'function') {
          window.RIO.refresh();
          return true;
        }
        if (window.reviewsio && typeof window.reviewsio.refresh === 'function') {
          window.reviewsio.refresh();
          return true;
        }
        if (window.RC && typeof window.RC.init === 'function') {
          window.RC.init();
          return true;
        }
      } catch (err) {
        console.warn('TU Sale: Reviews.io init error', err);
      }

      // Reviews.io noch nicht geladen → nochmal versuchen
      if (attempts < maxAttempts) {
        setTimeout(tryInit, 200);
      } else {
        console.warn('TU Sale: Reviews.io konnte nicht initialisiert werden – ist die App im Theme aktiv?');
      }
      return false;
    }

    tryInit();
  }


  /* ===========================================================
    SMOOTH SCROLL für Anker-Links (#bundle-hero, #produkte etc.)
    Berechnet Header-Höhe dynamisch (Sticky-Bar + ggf. Theme-Header)
  =========================================================== */
  function initSmoothScroll(section) {
    // Alle Links auf der ganzen Seite, die mit # starten und auf eine ID innerhalb der Section zeigen
    const links = document.querySelectorAll('a[href^="#"]');

    function getHeaderOffset() {
      let offset = 0;
      // 1. TerraUno Sticky Bar
      const stickyBar = document.querySelector('.tu-sticky-bar');
      if (stickyBar) offset += stickyBar.offsetHeight;
      // 2. Optional: Theme-Header (Vision-Theme nutzt typischerweise <header> oder .site-header)
      const themeHeader = document.querySelector('header[role="banner"], .site-header, .header-wrapper');
      if (themeHeader && getComputedStyle(themeHeader).position === 'sticky') {
        offset += themeHeader.offsetHeight;
      }
      return offset + 16; // 16 px Atem-Abstand
    }

    links.forEach(function(link) {
      const href = link.getAttribute('href');
      if (!href || href === '#' || href.length < 2) return;

      // Nur ankerinterne Links (keine externen URLs mit Hash)
      const isInternalAnchor = href.startsWith('#');
      if (!isInternalAnchor) return;

      link.addEventListener('click', function(e) {
        const target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        const top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }


  /* ===========================================================
    1. BUNDLE SIZE SELECTOR
  =========================================================== */
  function initBundleSelector(section) {
    const bundleBlocks = section.querySelectorAll('[data-tu-bundle-block]');
    if (!bundleBlocks.length) return;

    bundleBlocks.forEach(function(bundleEl) {
      initSingleBundle(bundleEl);
    });
  }

  function initSingleBundle(bundleEl) {
    const itemsList = bundleEl.querySelector('[data-tu-bundle-items]');
    const dataEl = bundleEl.querySelector('[data-tu-bundle-data]');

    let bundleData = {};
    if (dataEl) {
      try {
        bundleData = JSON.parse(dataEl.textContent);
      } catch (err) {
        console.error('TU Sale: bundle data parse error', err);
      }
    }

    // Items aus statischem JSON rendern (Fallback für Bundles OHNE Produkt-Variant-Daten)
    const staticItemsEl = bundleEl.querySelector('[data-tu-bundle-items-static]');
    if (staticItemsEl && itemsList) {
      try {
        const staticItems = JSON.parse(staticItemsEl.textContent);
        renderItems(itemsList, staticItems);
      } catch (err) {
        console.error('TU Sale: static bundle items parse error', err);
      }
    }

    const tabs = bundleEl.querySelectorAll('[data-tu-size-tab]');

    // Wenn Variant-Daten vorhanden: Items des aktiven Variants rendern (auch ohne Tabs)
    if (Object.keys(bundleData).length > 0 && itemsList) {
      let activeKey = null;
      const activeTab = bundleEl.querySelector('[data-tu-size-tab].is-active');
      if (activeTab) {
        activeKey = activeTab.dataset.tuSizeTab;
      } else {
        activeKey = Object.keys(bundleData)[0];
      }
      if (bundleData[activeKey] && bundleData[activeKey].items) {
        renderItems(itemsList, bundleData[activeKey].items);
      }
    }

    // Wenn keine Tabs, fertig
    if (!tabs.length) return;
    if (Object.keys(bundleData).length === 0) return;

    const body = bundleEl.querySelector('[data-tu-bundle-body]');
    const ribbon = bundleEl.querySelector('[data-tu-bundle-ribbon]');
    const titleSize = bundleEl.querySelector('[data-tu-bundle-size]');
    const uvpEl = bundleEl.querySelector('[data-tu-bundle-uvp]');
    const vkEl = bundleEl.querySelector('[data-tu-bundle-vk]');
    const savingEl = bundleEl.querySelector('[data-tu-bundle-saving]');
    const ctaDiscountEl = bundleEl.querySelector('[data-tu-bundle-cta-discount]');
    const ctaButton = bundleEl.querySelector('[data-tu-bundle-cta]');
    const mediaImg = bundleEl.querySelector('.tu-bundle-card__media img');
    const defaultImageSrc = mediaImg ? mediaImg.src : '';

    function renderBundle(sizeKey) {
      const data = bundleData[sizeKey];
      if (!data) return;

      if (body) body.classList.add('is-fading');

      setTimeout(function() {
        if (titleSize) titleSize.textContent = data.label || '';
        if (uvpEl) uvpEl.textContent = data.uvp || '';
        if (vkEl) vkEl.textContent = data.vk || '';
        if (savingEl) savingEl.textContent = data.saving || '';
        if (ctaDiscountEl) ctaDiscountEl.textContent = data.discount || '';
        if (ribbon && data.discount) {
          ribbon.textContent = '– ' + data.discount + ' % SPAREN';
        }
        if (ctaButton && data.variant_id) {
          ctaButton.dataset.tuVariantId = data.variant_id;
        }

        // Variant-Bild updaten: wenn Variante eigenes Bild hat → wechseln, sonst Fallback auf Default
        if (mediaImg) {
          let newSrc = data.image && data.image.length > 0 ? data.image : defaultImageSrc;
          // Protocol-relative URLs (//cdn.shopify.com/…) zu https:// machen
          if (newSrc && newSrc.indexOf('//') === 0) {
            newSrc = 'https:' + newSrc;
          }
          if (newSrc) {
            mediaImg.classList.add('is-fading');
            const tmpImg = new Image();
            tmpImg.onload = function() {
              mediaImg.src = newSrc;
              if (mediaImg.srcset) mediaImg.srcset = '';
              mediaImg.classList.remove('is-fading');
            };
            tmpImg.onerror = function() {
              mediaImg.classList.remove('is-fading');
            };
            tmpImg.src = newSrc;
          }
        }

        if (itemsList && data.items) {
          renderItems(itemsList, data.items);
        }

        if (body) body.classList.remove('is-fading');
      }, 200);
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        if (tab.classList.contains('is-unavailable')) return;
        tabs.forEach(function(t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        renderBundle(tab.dataset.tuSizeTab);
      });
    });

    const activeTab = bundleEl.querySelector('[data-tu-size-tab].is-active');
    if (activeTab) {
      renderBundle(activeTab.dataset.tuSizeTab);
    }
  }

  function renderItems(itemsList, items) {
    itemsList.innerHTML = items.map(function(item) {
      const iconClass = item.is_gift
        ? 'tu-bundle-card__item-icon--gift'
        : 'tu-bundle-card__item-icon--check';
      // SVG-Icons statt Emoji – siehe TU_ICONS unten
      const icon = item.is_gift ? TU_ICONS.gift : TU_ICONS.check;
      return '<li class="tu-bundle-card__item">' +
        '<span class="tu-bundle-card__item-icon ' + iconClass + '">' + icon + '</span>' +
        '<span>' + item.text + '</span>' +
        '</li>';
    }).join('');
  }


  /* ===========================================================
    2. COUNTDOWN
  =========================================================== */
  function initCountdown(section) {
    let targetStr = section.dataset.tuCountdownEnd;
    if (!targetStr) return;

    // Häufige Editor-Tippfehler abfangen: versehentlich mitkopierte Klammern
    // aus dem Beispiel-Label, Leerzeichen, Anführungszeichen.
    targetStr = targetStr.trim().replace(/[()"']/g, '').trim();

    let target = new Date(targetStr);
    // Fallback: Safari/ältere Browser mögen kein "T" ohne Zeitzone – normalisieren
    if (isNaN(target.getTime()) && /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/.test(targetStr)) {
      target = new Date(targetStr.replace(' ', 'T'));
    }
    if (isNaN(target.getTime())) {
      console.warn('TU Sale: ungültiges Countdown-Datum:', section.dataset.tuCountdownEnd,
        '– bitte Format 2026-08-02T23:59:00 verwenden (ohne Klammern/Leerzeichen).');
      return;
    }

    const slots = {
      d: section.querySelectorAll('[data-tu-cd="days"]'),
      h: section.querySelectorAll('[data-tu-cd="hours"]'),
      m: section.querySelectorAll('[data-tu-cd="minutes"]'),
      s: section.querySelectorAll('[data-tu-cd="seconds"]')
    };

    function pad(n) { return String(n).padStart(2, '0'); }

    function update() {
      const diff = target.getTime() - Date.now();
      let d, h, m, s;
      if (diff <= 0) {
        d = h = m = s = '00';
      } else {
        d = pad(Math.floor(diff / 86400000));
        h = pad(Math.floor((diff % 86400000) / 3600000));
        m = pad(Math.floor((diff % 3600000) / 60000));
        s = pad(Math.floor((diff % 60000) / 1000));
      }
      slots.d.forEach(function(el) { el.textContent = d; });
      slots.h.forEach(function(el) { el.textContent = h; });
      slots.m.forEach(function(el) { el.textContent = m; });
      slots.s.forEach(function(el) { el.textContent = s; });
    }

    update();
    setInterval(update, 1000);

    // ===== Hero-Countdown (1c) – nutzt dieselbe Zieldaten =====
    const heroCd = section.querySelector('[data-tu-hero-countdown]');
    if (heroCd) {
      const hSlots = {
        d: heroCd.querySelector('[data-tu-cd-days]'),
        h: heroCd.querySelector('[data-tu-cd-hours]'),
        m: heroCd.querySelector('[data-tu-cd-mins]'),
        s: heroCd.querySelector('[data-tu-cd-secs]')
      };
      function updateHero() {
        const diff = target.getTime() - Date.now();
        let d, h, m, s;
        if (diff <= 0) { d = h = m = s = '00'; }
        else {
          d = pad(Math.floor(diff / 86400000));
          h = pad(Math.floor((diff % 86400000) / 3600000));
          m = pad(Math.floor((diff % 3600000) / 60000));
          s = pad(Math.floor((diff % 60000) / 1000));
        }
        if (hSlots.d) hSlots.d.textContent = d;
        if (hSlots.h) hSlots.h.textContent = h;
        if (hSlots.m) hSlots.m.textContent = m;
        if (hSlots.s) hSlots.s.textContent = s;
      }
      updateHero();
      setInterval(updateHero, 1000);
    }
  }


  /* ===========================================================
    3. INFO POPUP
  =========================================================== */
  function initInfoPopup(section) {
    const popup = section.querySelector('[data-tu-popup]');
    if (!popup) return;

    const panel = popup.querySelector('[data-tu-popup-panel]');
    const closeBtn = popup.querySelector('[data-tu-popup-close]');
    const slots = {
      title: popup.querySelector('[data-tu-popup-title]'),
      category: popup.querySelector('[data-tu-popup-category]'),
      media: popup.querySelector('[data-tu-popup-media]'),
      content: popup.querySelector('[data-tu-popup-content]'),
      cta: popup.querySelector('[data-tu-popup-cta]')
    };

    function openPopup(productId) {
      const dataEl = section.querySelector('[data-tu-product-info="' + productId + '"]');
      if (!dataEl) return;
      let data = {};
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      // Holt aktuell ausgewählte Variant-ID aus der Karte (falls Variant-Selector vorhanden)
      const productCard = section.querySelector('[data-tu-product-block="' + productId + '"]');
      let currentVariantId = data.variant_id;
      if (productCard) {
        const cardCartBtn = productCard.querySelector('[data-tu-add-to-cart]');
        if (cardCartBtn && cardCartBtn.dataset.tuVariantId) {
          currentVariantId = cardCartBtn.dataset.tuVariantId;
        }
      }

      if (slots.category) slots.category.textContent = data.category || '';
      if (slots.title) slots.title.textContent = data.title || '';

      if (slots.media) {
        slots.media.innerHTML = data.image_url
          ? '<img src="' + data.image_url + '" alt="' + (data.title || '') + '" loading="lazy">'
          : '<span style="color:#6b8a1d;font-weight:600;">[Produktbild]</span>';
      }

      if (slots.content) {
        if (data.use_description && data.description_html) {
          // Shopify-Produktbeschreibung (ist bereits HTML) direkt einsetzen
          slots.content.innerHTML = '<div class="tu-popup__section tu-popup__description">' + data.description_html + '</div>';
        } else if (data.sections) {
          // Sektionen – leere (ohne Überschrift UND Text) überspringen
          slots.content.innerHTML = data.sections.filter(function(sec) {
            return (sec.heading && sec.heading.trim()) || (sec.text && sec.text.trim());
          }).map(function(sec) {
            return '<div class="tu-popup__section">' +
              (sec.heading ? '<h3>' + sec.heading + '</h3>' : '') +
              (sec.text ? '<p>' + sec.text + '</p>' : '') +
              '</div>';
          }).join('');
        }
      }

      if (slots.cta) {
        slots.cta.dataset.tuVariantId = currentVariantId || '';
        const svg = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
        slots.cta.innerHTML = svg + ' ' + (data.cta_label || 'In den Warenkorb');
      }

      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tu-popup-open');
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tu-popup-open');
    }

    section.querySelectorAll('[data-tu-info-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openPopup(btn.dataset.tuInfoTrigger);
      });
    });

    // Bundle-Info-Trigger: nutzt das gleiche Popup, andere Datenquelle
    section.querySelectorAll('[data-tu-bundle-info-trigger]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openBundlePopup(btn.dataset.tuBundleInfoTrigger);
      });
    });

    function openBundlePopup(bundleId) {
      const dataEl = section.querySelector('[data-tu-bundle-info="' + bundleId + '"]');
      if (!dataEl) return;
      let data = {};
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      // Aktuell ausgewählte Variant-ID aus dem Bundle-CTA-Button ziehen
      const bundleEl = section.querySelector('[data-tu-bundle-block="' + bundleId + '"]');
      let currentVariantId = data.variant_id;
      if (bundleEl) {
        const cartBtn = bundleEl.querySelector('[data-tu-bundle-cta]');
        if (cartBtn && cartBtn.dataset.tuVariantId) {
          currentVariantId = cartBtn.dataset.tuVariantId;
        }
      }

      if (slots.category) slots.category.textContent = data.category || '';
      if (slots.title) slots.title.textContent = data.title || '';

      if (slots.media) {
        slots.media.innerHTML = data.image_url
          ? '<img src="' + data.image_url + '" alt="' + (data.title || '') + '" loading="lazy">'
          : '<span style="color:#6b8a1d;font-weight:600;">[Bundle-Bild]</span>';
      }

      // Description als HTML (richtext)
      if (slots.content) {
        slots.content.innerHTML = data.description
          ? '<div class="tu-popup__bundle-description">' + data.description + '</div>'
          : '';
      }

      if (slots.cta) {
        slots.cta.dataset.tuVariantId = currentVariantId || '';
        const svg = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
        slots.cta.innerHTML = svg + ' ' + (data.cta_label || 'In den Warenkorb');
      }

      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tu-popup-open');
    }

    if (closeBtn) closeBtn.addEventListener('click', closePopup);

    popup.addEventListener('click', function(e) {
      if (e.target === popup) closePopup();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) {
        closePopup();
      }
    });

    if (panel) {
      let touchStartY = 0;
      panel.addEventListener('touchstart', function(e) {
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      panel.addEventListener('touchmove', function(e) {
        if (panel.scrollTop > 0) return;
        const diff = e.touches[0].clientY - touchStartY;
        if (diff > 80) closePopup();
      }, { passive: true });
    }
  }


  /* ===========================================================
    4. VARIANT SELECTORS (für Einzelprodukte mit Varianten)
  =========================================================== */
  function initVariantSelectors(section) {
    // Initial-Render aller Produkt-Karten (auch bei nur einer Variante,
    // damit Preise/Saving aus Shopify-Daten gesetzt werden)
    section.querySelectorAll('[data-tu-product-block]').forEach(function(productCard) {
      const variantsDataEl = productCard.querySelector('[data-tu-variants-data]');
      let variantsData = [];
      if (variantsDataEl) {
        try { variantsData = JSON.parse(variantsDataEl.textContent); } catch (e) { variantsData = []; }
      }

      // Preise/Default nur setzen, wenn Varianten-Daten da sind.
      if (variantsData.length) {
        let defaultVariant = null;
        const preselected = productCard.querySelector('[data-tu-variant-option].is-selected');
        if (preselected) {
          const preId = preselected.dataset.tuVariantOption;
          defaultVariant = variantsData.find(function(v) { return String(v.id) === String(preId); });
        }
        if (!defaultVariant) {
          defaultVariant = variantsData.find(function(v) { return v.available; }) || variantsData[0];
        }
        applyVariant(productCard, defaultVariant);
      }

      // Klick-Logik IMMER registrieren – auch ohne Varianten-Daten. So bleibt
      // der Varianten-Wechsel funktionsfähig, selbst wenn die Preisdaten fehlen.
      const selector = productCard.querySelector('[data-tu-variant-selector]');
      if (!selector) return;

      const options = selector.querySelectorAll('[data-tu-variant-option]');
      options.forEach(function(opt) {
        opt.addEventListener('click', function() {
          if (opt.classList.contains('is-unavailable')) return;
          if (opt.classList.contains('is-single')) return;
          const variantId = opt.dataset.tuVariantOption;
          options.forEach(function(o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');

          // Preise etc. nur wenn Varianten-Daten vorhanden
          const variant = variantsData.find(function(v) { return String(v.id) === String(variantId); });
          if (variant) {
            applyVariant(productCard, variant);
          } else if (productCard._tuCardSlider) {
            // Fallback ohne Varianten-Daten: Bild direkt per Button-Text (= Titel) wechseln
            productCard._tuCardSlider.setVariantImage(opt.textContent.trim(), true);
          }
        });
      });
    });
  }

  // Setzt UVP, Sale-Preis, Ersparnis-Badge und Variant-ID basierend auf Shopify-Daten
  function applyVariant(productCard, variant) {
    if (!variant) return;

    const cartBtn = productCard.querySelector('[data-tu-add-to-cart]');
    const priceVk = productCard.querySelector('[data-tu-product-price-vk]');
    const priceUvp = productCard.querySelector('[data-tu-product-price-uvp]');
    const percentEl = productCard.querySelector('[data-tu-product-percent]');
    const chipEl = productCard.querySelector('[data-tu-product-chip]');
    const flagEl = productCard.querySelector('[data-tu-price-flag]');

    // Variant-ID auf Cart-Button setzen
    if (cartBtn) cartBtn.dataset.tuVariantId = variant.id;

    // Sale-Preis (Shopify gibt Preise in Cent, wir bekommen aber bereits formatierte money-Strings)
    if (priceVk && variant.price_formatted) {
      priceVk.textContent = variant.price_formatted;
    }

    // UVP nur zeigen, wenn Compare-at-Price > Price
    const hasDiscount = variant.compare_at_price_cents && variant.compare_at_price_cents > variant.price_cents;

    if (priceUvp) {
      if (hasDiscount && variant.compare_at_price_formatted) {
        priceUvp.textContent = (priceUvp.dataset.tuPrefix || '') + ' ' + variant.compare_at_price_formatted;
        priceUvp.style.display = '';
      } else {
        priceUvp.style.display = 'none';
      }
    }

    // Prozent-Ersparnis als Text in der Fahne
    if (percentEl) {
      percentEl.textContent = (hasDiscount && variant.saving_percent)
        ? '−' + variant.saving_percent + ' %' : '';
    }
    // Schwarzen Chip nur zeigen, wenn Rabatt da
    if (chipEl) chipEl.style.display = hasDiscount ? '' : 'none';
    // Bei fehlendem Rabatt die rote Fahne neutral schalten (kein Rot ohne Deal)
    if (flagEl) flagEl.classList.toggle('tu-price-flag--no-discount', !hasDiscount);

    // Bild-Slider: erstes Bild auf das manuell zugeordnete Varianten-Bild tauschen
    // (Zuordnung per Varianten-Titel im Theme-Editor).
    if (productCard._tuCardSlider && variant.title) {
      productCard._tuCardSlider.setVariantImage(variant.title, !productCard._tuVariantInit);
    }
    productCard._tuVariantInit = true;
  }


  /* ===========================================================
    5. QUICK ADD TO CART (mit Doppelklick-Schutz)
  =========================================================== */
  function initQuickAdd(section) {
    section.querySelectorAll('[data-tu-add-to-cart]').forEach(function(btn) {
      // Wir merken uns den Original-Inhalt einmalig
      btn.dataset.tuOriginalHtml = btn.innerHTML;

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // ===== Doppelklick-Schutz =====
        if (btn.dataset.tuBusy === '1') return;
        if (btn.disabled) return;

        const variantId = btn.dataset.tuVariantId;
        if (!variantId) {
          console.warn('TU Sale: keine variant_id auf Button');
          alert('Bitte zuerst eine Variante auswählen.');
          return;
        }

        btn.dataset.tuBusy = '1';
        btn.disabled = true;

        const originalHTML = btn.dataset.tuOriginalHtml || btn.innerHTML;
        btn.innerHTML = '⏳ Wird hinzugefügt …';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Cart add failed: ' + res.status);
          return res.json();
        })
        .then(function() {
          btn.innerHTML = TU_ICONS.check + ' Im Warenkorb';

          // ===== Cart-Drawer öffnen (nur wenn im Theme-Editor aktiviert) =====
          const shouldOpenDrawer = section.dataset.tuOpenCartDrawer !== 'false';

          if (shouldOpenDrawer) {
            // UpCart bietet mehrere Mechanismen – wir probieren sie in Reihenfolge der Zuverlässigkeit:

            // 1. Offizielle UpCart-API (am zuverlässigsten)
            if (typeof window.openUpcart === 'function') {
              window.openUpcart();
            }
            // 2. UpCart Custom Event
            else if (typeof document.dispatchEvent === 'function') {
              document.dispatchEvent(new CustomEvent('upcart:open'));
              // 3. Generisches Cart-Refresh-Event (UpCart lauscht oft mit)
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              // 4. UpCart-Toggle-Element klicken (Fallback)
              const upcartToggle = document.querySelector('.upcart-toggle, [data-upcart-toggle], #upcart-toggle');
              if (upcartToggle && typeof upcartToggle.click === 'function') {
                upcartToggle.click();
              }
              // 5. Letzter Fallback: Cart-Icon-Klick (öffnet UpCart, da App diesen Klick abfängt)
              else {
                const cartIcon = document.querySelector('[data-cart-icon-bubble], [data-header-cart], #cart-icon-bubble, a[href="/cart"]');
                if (cartIcon && typeof cartIcon.click === 'function') {
                  cartIcon.click();
                }
              }
            }
          } else {
            // Drawer-Öffnung deaktiviert – nur Cart-Count im Header aktualisieren
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }

          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
            btn.dataset.tuBusy = '0';
          }, 2000);
        })
        .catch(function(err) {
          console.error('TU Sale Cart Error:', err);
          btn.innerHTML = '✗ Fehler – nochmal?';
          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
            btn.dataset.tuBusy = '0';
          }, 2500);
        });
      });
    });
  }


  /* ===== AUTO-INIT ===== */
  function initAll() {
    document.querySelectorAll('[data-tu-sale-section]').forEach(initSaleSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme-Editor: Wenn Section neu geladen wird, das Initialisiert-Flag zurücksetzen
  document.addEventListener('shopify:section:load', function(e) {
    const section = e.target.querySelector('[data-tu-sale-section]');
    if (section) {
      section.removeAttribute('data-tu-initialized');
      initSaleSection(section);
    }
  });

  document.addEventListener('shopify:section:unload', function(e) {
    const section = e.target.querySelector('[data-tu-sale-section]');
    if (section) section.removeAttribute('data-tu-initialized');
  });

})();